import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "@/contexts/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Recipes from "@/pages/Recipes";
import RecipeDetail from "@/pages/RecipeDetail";
import About from "@/pages/About";
import OurStory from "@/pages/OurStory";
import Stories from "@/pages/Stories";
import AphroditesRoots from "@/pages/AphroditesRoots";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminRecipeForm from "@/pages/AdminRecipeForm";

function App() {
    return (
        <div className="App min-h-screen hl-grain-fixed">
            <BrowserRouter>
                <AuthProvider>
                    <Navbar />
                    <main>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/recipes" element={<Recipes />} />
                            <Route path="/recipes/:slug" element={<RecipeDetail />} />
                            <Route path="/stories" element={<Stories />} />
                            <Route path="/aphrodites-roots" element={<AphroditesRoots />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/our-story" element={<OurStory />} />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                            <Route path="/admin/new" element={<ProtectedRoute><AdminRecipeForm /></ProtectedRoute>} />
                            <Route path="/admin/edit/:id" element={<ProtectedRoute><AdminRecipeForm /></ProtectedRoute>} />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </main>
                    <Footer />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
